<ng-select
  [items]="dispositivos"
  [placeholder]="placeholder"
  loadingText="Cargando..."
  typeToSearchText="Buscar..."
  notFoundText="No se encontraron resultados"
  [bindValue]="bindValue"
  [searchFn]="searchDispositivo"
  [appendTo]="appendTo"
  [clearable]="clearable"
  [disabled]="disabled"
  [ngModel]="value"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onValueChange($event)"
  (blur)="onTouched()"
>
  <ng-template ng-label-tmp let-item="item">
    {{ nombreOf(item) || "(sin nombre)"
    }}@if (euiOf(item)) { — {{ euiOf(item) }} }
    @if (firmwareOf(item)) {
      <small class="no-info"> · FW: {{ firmwareOf(item) }}</small>
    }
    @if (hardwareOf(item)) {
      <small class="no-info"> · HW: {{ hardwareOf(item) }}</small>
    }
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span>{{ nombreOf(item) || "(sin nombre)" }}</span>
    @if (euiOf(item)) {
      <small class="no-info"> — {{ euiOf(item) }}</small>
    }
    @if (firmwareOf(item)) {
      <small class="no-info"> · FW: {{ firmwareOf(item) }}</small>
    }
    @if (hardwareOf(item)) {
      <small class="no-info"> · HW: {{ hardwareOf(item) }}</small>
    }
  </ng-template>
</ng-select>
